export const linkedin = () => (
  <path
    d="M21.4062 1C22.3041 1 23 1.70929 23 2.58301V21.416C23 22.2908 22.0423 23 21.1445 23H2.39648C1.49973 23 1.00001 22.2908 1 21.416V2.58301C1 1.70935 1.76152 1.00009 2.6582 1H21.4062ZM4.14258 9.38086V19.8574H7.28613V9.38086H4.14258ZM15.8096 9.25C14.1606 9.25 12.8265 10.0766 12.375 10.8906H12.3428V9.38086H9.38086V19.8574H12.5234V14.8252C12.5235 13.0697 13.277 12.0002 14.8564 12C16.1576 12 16.7139 13.2229 16.7139 14.6162V19.8574H19.8574V14.043C19.8574 10.9306 18.9741 9.25015 15.8096 9.25ZM5.71387 3.75C4.62887 3.75023 3.75023 4.62887 3.75 5.71387C3.75 6.79906 4.62873 7.67848 5.71387 7.67871C6.7992 7.67871 7.67871 6.7992 7.67871 5.71387C7.67848 4.62873 6.79906 3.75 5.71387 3.75Z"
    fillRule="evenodd"
    clipRule="evenodd"
    fill="inherit"
  />
);
